/** 提示词配置模式 */
export const PROMPT_MODE = {
  FREE: 'free',
  STRUCTURED: 'structured',
}

/** 结构化模式中「角色与人设」区块键（仅 UI 排序，数据写入 role_setting） */
export const ROLE_PERSONA_SECTION_KEY = 'rolePersona'

export const ROLE_PERSONA_META = {
  title: '角色与人设',
  promptTitle: '角色与人设',
}

/** 自定义内容块 id 前缀（flowSectionOrder 中为 custom:<id>） */
export const CUSTOM_FLOW_PREFIX = 'custom:'

export const CUSTOM_SECTION_BODY_MAX = 5000

/** 提示词配置 Tab 内默认区块顺序（含角色与人设 + 业务块） */
export const DEFAULT_PROMPT_SECTION_ORDER = [
  ROLE_PERSONA_SECTION_KEY,
  'businessBackground',
  'businessTarget',
  'businessProcess',
  'opening',
  'dialogueConstraint',
  'questionConstraint',
]

/** 业务 Tab 内全部可拖拽区块（顺序与内容写入 llmsettings.business_flow） */
export const FLOW_SECTION_KEYS = [
  'businessBackground',
  'businessTarget',
  'businessProcess',
  // 'intentTag',
  'opening',
  // 'dialogueExample',
  'dialogueConstraint',
  'questionConstraint',
]

/** 各区块标题、字数与预览用二级标题（promptTitle）；配置指引：isShowGuide + guideSuggestion / guideExample */
export const FLOW_SECTION_META = {
  opening: {
    title: '开场白',
    placeholder: '请输入开场白...',
    maxlength: 200,
    rows: 8,
    promptTitle: '开场白',
    insertParam: true,
    isShowGuide: false,
    guideSuggestion: '',
    guideExample: '',
  },
  businessTarget: {
    title: '通话目标',
    placeholder: '请输入通话目标...',
    maxlength: 2000,
    rows: 8,
    promptTitle: '通话目标',
    insertParam: true,
    isShowGuide: true,
    guideSuggestion:
      '列出1~3个最核心的目标，目标越聚焦，AI越不容易跑题、扯闲篇。',
    guideExample:
      '1.核实接听者是否为本人；\n2.用两句话简单介绍XX产品的核心优势；\n3.询问客户近期是否有了解该产品的意愿，并尝试添加企业微信。',
  },
  businessBackground: {
    title: '业务背景',
    placeholder: '请输入业务背景...',
    maxlength: 2000,
    rows: 8,
    promptTitle: '业务背景',
    insertParam: true,
    isShowGuide: true,
    guideSuggestion:
      '补充客户的基本信息、来源渠道或历史交集，能让AI的开场显得更合理，避免像“陌生的推销电话”引起反感。',
    guideExample:
      '客户昨天在官网填写了手机号，下载了我们的试用资料。本次电话的背景是跟进他的资料获取情况，属于“线索激活”场景。',
  },
  businessProcess: {
    title: '业务流程',
    placeholder: '请输入业务流程...',
    maxlength: 5000,
    rows: 8,
    promptTitle: '业务流程',
    insertParam: true,
    isShowGuide: true,
    guideSuggestion:
      '请按先后顺序，描述AI应该按什么步骤推进这通电话（第一步做什么，第二步做什么）。清晰的步骤能防止AI逻辑混乱或颠三倒四。',
    guideExample:
      '1. 先问候并自报家门，说明来意；\n2. 简单确认客户的基本条件是否符合要求；\n3. 如果符合，介绍产品核心卖点；如果不符合，礼貌挂断；\n4. 探听客户意向，抛出邀约或加微动作。',
  },
  dialogueConstraint: {
    title: '通话约束',
    placeholder: '请输入通话约束说明...',
    maxlength: 2000,
    rows: 8,
    promptTitle: '通话约束',
    insertParam: true,
    isShowGuide: true,
    guideSuggestion:
      '告诉AI哪些话绝对不能说、哪些承诺绝对不能做，以及在什么情况下必须马上转交人工处理。这是保障业务合规、避免客诉的关键。',
    guideExample:
      '绝对不能编造不存在的优惠活动；不能向客户保证“绝对能赚多少钱/绝对能治好”等无法兑现的结果；如果客户表现出明显的不耐烦、要求投诉或询问具体的退款金额，必须立即说“帮您转接人工”并结束对话。',
  },
  questionConstraint: {
    title: '常见问题',
    placeholder: '请输入常见问题...',
    maxlength: 2000,
    rows: 8,
    promptTitle: '常见问题',
    insertParam: true,
    isShowGuide: true,
    guideSuggestion: '整理高频问答要点，模型可优先按此回应，减少事实性错误。',
    guideExample:
      '问：课程可以退费吗？\n答：按报名协议，开课前 N 天可全额退费，开课后按课时规则处理。',
  },
}
